import React from 'react'
import { useState } from 'react'

const faqs = [
  { question: "Qual a área de atuação do escritório?", answer: "Atuamos nas áreas trabalhista e previdenciária." },
  { question: "Qual o local de atuação do escritório?", answer: "A sede do nosso escritório é localizada na cidade de Sorocaba-SP, e nossa atuação se estende a todo território nacional." },
  { question: "Como faço para falar com um advogado?", answer: <>Basta clicar <a href="https://tintim.link/whatsapp/f29b407c-6594-4bba-b0aa-f5442f711a68/e7405481-419a-4fdb-8030-9aee45f67a3a" target="_blank" rel="noreferrer" style={{ color: 'var(--accent)', textDecoration: 'underline' }}>neste link</a>!</> },
  { question: "Quais são os direitos de um trabalhador em caso de demissão sem justa causa?", answer: "Quando o trabalhador é demitido sem justa causa, ele tem direito a receber verbas rescisórias como aviso prévio, multa de 40% sobre o FGTS, saque do saldo do FGTS, seguro-desemprego (se elegível), 13º salário proporcional e férias proporcionais acrescidas de 1/3." },
  { question: "Como funcionam as horas extras e quais são os meus direitos?", answer: "As horas extras são aquelas trabalhadas além da jornada regular de trabalho. Elas devem ser remuneradas com um acréscimo de, no mínimo, 50% sobre o valor da hora normal. Nos casos de trabalho aos domingos e feriados, o acréscimo pode ser maior, conforme previsto na legislação ou em acordos coletivos." },
  { question: "Quais são os direitos das gestantes no ambiente de trabalho?", answer: "A trabalhadora gestante tem direito à estabilidade no emprego desde a confirmação da gravidez até cinco meses após o parto. Além disso, ela tem direito à licença-maternidade de 120 dias, com possibilidade de prorrogação em alguns casos, e a condições especiais de trabalho que preservem sua saúde e a do bebê." },
  { question: "É possível fazer tudo online?", answer: "Sim, nosso escritório atende tanto de forma presencial como online, para garantir maior acessibilidade do cliente aos nossos serviços." },
]

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [heights, setHeights] = useState({});
  const refs = faqs.reduce((acc, _, index) => {
    acc[index] = React.createRef();
    return acc;
  }, {});

  const toggle = (i) => {
    if (activeIndex === i) {
      setActiveIndex(null);
    } else {
      setActiveIndex(i);
      if (!heights[i] && refs[i].current) {
        const height = refs[i].current.scrollHeight;
        setHeights(prev => ({...prev, [i]: height}));
      }
    }
  }

  return (
    <section>
      <h2 className="section-title">Perguntas Frequentes</h2>
      <div style={{maxWidth: '800px', margin: '0 auto'}}>
        {faqs.map((faq, i) => (
          <div key={i} style={{ 
            marginBottom: '1rem',
            borderBottom: '1px solid var(--accent)',
            transition: 'all 0.3s ease-in-out'
          }}>
            <button 
              onClick={() => toggle(i)}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '1rem',
                background: activeIndex === i ? 'var(--dark-gray)' : 'transparent',
                color: activeIndex === i ? 'var(--accent)' : 'var(--white)',
                borderRadius: '3px',
                border: 'none',
                fontSize: '1.1rem',
                fontWeight: '500',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                position: 'relative',
                transition: 'all 0.3s ease-in-out'
              }}
            >
              {faq.question}
              <span style={{
                transform: activeIndex === i ? 'rotate(45deg)' : 'none',
                transition: 'transform 0.4s ease-in-out'
              }}>+</span>
            </button>
            <div
              ref={refs[i]}
              style={{
                height: activeIndex === i ? (heights[i] ? `${heights[i]}px` : 'auto') : '0',
                overflow: 'hidden',
                padding: activeIndex === i ? '1rem' : '0 1rem',
                opacity: activeIndex === i ? 1 : 0,
                transition: 'all 0.4s ease-in-out'
              }}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}